var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "24px",
    height: "24px",
    viewBox: "0 0 0.72 0.72",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.627 0.06H0.093A0.033 0.033 0 0 0 0.06 0.093v0.534A0.033 0.033 0 0 0 0.093 0.66h0.287v-0.232h-0.078v-0.09h0.078V0.27a0.109 0.109 0 0 1 0.116 -0.12 0.6 0.6 0 0 1 0.07 0.004v0.081H0.519c-0.038 0 -0.045 0.018 -0.045 0.044v0.058h0.09l-0.012 0.09H0.474V0.66h0.153a0.033 0.033 0 0 0 0.033 -0.033V0.093A0.033 0.033 0 0 0 0.627 0.06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b6bb1a6bf1433b70ee10a8d711a1338a.svg";
export { ForwardRef as ReactComponent };